import { render, staticRenderFns } from "./V2DealPackCardSmall.vue?vue&type=template&id=929db112&scoped=true&"
import script from "./V2DealPackCardSmall.vue?vue&type=script&lang=js&"
export * from "./V2DealPackCardSmall.vue?vue&type=script&lang=js&"
import style0 from "./V2DealPackCardSmall.vue?vue&type=style&index=0&id=929db112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929db112",
  null
  
)

export default component.exports